import { createI18n } from 'vue-i18n'

import ja from '@/locales/ja.json'

export const i18nPlugin = createI18n({
  legacy: false,
  globalInstall: true,
  globalInjection: true,
  locale: process.env.VUE_APP_I18N_LOCALE || 'ja',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'ja',
  messages: { ja }
})
